import 'foundation-sites/dist/css/foundation.min.css';
import 'foundation-sites/dist/js/foundation.min.js';

import "./Section.css"

const Section = () => (<section className="Section" style={{marginTop: '150px'}}>
        <div className="grid-container full">
            <div className="grid-container">
                <div className="row">
                    <div className="columns large-12">
                        <h1 className="iransans center-in-small" style={{
                            fontSize: '30px', margin: '50px 0', color: '#066137', textAlign: 'right', fontWeight: 800,
                        }}>چطور اعتبار بگیرم؟</h1>
                    </div>
                </div>
            </div>
            <div class="grid-container">
                <div className="grid-x grid-margin-x align-center">
                    <div className="cell small-12 large-2">
                        <div className="image-container">
                            <img src="/public/credit/assets/img/laptop.png" alt="laptop"/>
                        </div>
                        <div className="image-text center-in-small">درخواست دریافت اعتبار</div>
                    </div>

                    <div className="cell small-4 large-2 hide-for-small-only alignCenter">
                        <div className="image-container-peykan">
                        <img src="/public/credit/assets/img/peykan.png" alt="peykan"/>
                        </div>
                    </div>

                    <div className="cell small-12 large-2">
                        <div className="image-container">
                            <img src="/public/credit/assets/img/transfer.png" alt="transfer"/>
                        </div>
                        <div className="image-text center-in-small">انتقال پرتفوی به فارابی</div>
                    </div>

                    <div className="cell small-4 large-2 hide-for-small-only alignCenter">
                        <div className="image-container-peykan">
                        <img src="/public/credit/assets/img/peykan.png" alt="peykan"/>
                        </div>
                    </div>


                    <div className="cell small-12 large-2">
                        <div className="image-container">
                            <img src="/public/credit/assets/img/document.png"
                                 alt="document"/>
                        </div>
                        <div className="image-text">ارائه گردش سه ماه آخر</div>
                    </div>

                </div>
            </div>
        </div>
</section>);

export default Section;
